export default __webpack_public_path__ + "static/media/Team Scheduler.057bce41.png";